import apiClient from '@/plugins/axios'

export default {
  getPagamentoProcessos() {
    return apiClient.get('pagamentosProcesso')
  },

  getPagamentoProcesso(id) {
    return apiClient.get(`pagamentosProcesso/${id}`)
  },

  postPagamentoProcesso(pagamento_processo) {
    return apiClient.post(`pagamentosProcesso`, { pagamento_processo })

  },

  putPagamentoProcesso(id, pagamento_processo) {
    return apiClient.put(`pagamentosProcesso/${id}`, { pagamento_processo })

  },

  deletePagamentoProcesso(id) {
    return apiClient.delete(`pagamentosProcesso/${id}`)

  },

}


// WEBPACK FOOTER //
// ./src/views/Pagamentos/_services/PagamentoProcesso.js